import { createSlice } from "@reduxjs/toolkit";
import { getDriverReviews } from "./driverReviewsActions";

const initialState = {
  loading: false,
  error: null,
  reviews: {
    content: [],
    page: {
      number: 0,
      size: 10,
      totalElements: 0,
      totalPages: 0,
    },
  },
};

const driverReviewsSlice = createSlice({
  name: "driverReviews",
  initialState,
  reducers: {
    resetDriverReviews: () => initialState,
  },
  extraReducers: (builder) => {
    builder
      .addCase(getDriverReviews.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getDriverReviews.fulfilled, (state, action) => {
        state.loading = false;
        state.reviews = action.payload;
      })
      .addCase(getDriverReviews.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export const { resetDriverReviews } = driverReviewsSlice.actions;
export default driverReviewsSlice.reducer;
